import header from './sections/header'
import previousTreatments from './sections/previousTreatments'
import treatmentDetails from './sections/treatmentDetails'
import symptoms from './sections/symptoms'
import labExams from './sections/labExams'
import spirometry from './sections/spirometry'
import footer from './sections/footer'

const sections = {
  header,
  previousTreatments,
  treatmentDetails,
  symptoms,
  labExams,
  spirometry,
  footer,
}

/** @type {(section: keyof typeof sections, version: number) => ((data: any) => string[])?} */
export function getSectionGenerator(section, version) {
  const sectionGenerators = sections[section]

  const foundGenerator = sectionGenerators.find(({ version: generatorVersion }) => {
    if (generatorVersion.include.length && !generatorVersion.include.includes(version)) {
      return false
    }
    if (generatorVersion.exclude.length && generatorVersion.exclude.includes(version)) {
      return false
    }
    return true
  })

  return foundGenerator?.generate ?? null
}
